namespace Serenity.Extensions {
    export interface ExcelImportRequest extends ServiceRequest {
        FileName?: string;
    }
}
